/** URLs canônicas das páginas do menu de perfil e áreas administrativas. */
export const APP_PATHS = {
  SUBSCRIPTION: '/subscription',
  SETTINGS: '/settings',
  USERS: '/users',
  ROLES: '/roles',
};

export const getRoleEditPath = (roleId) => `${APP_PATHS.ROLES}/${roleId}/edit`;
export const getRoleNewPath = () => `${APP_PATHS.ROLES}/new`;
